module.exports = __webpack_public_path__ + "img/result.c4037ec0.png";